import { useQuery } from "@tanstack/react-query";

import { ConsentSubjectType, fetchContactConsent } from "@/services/consent";

export function useContactConsent(subjectType: ConsentSubjectType, subjectId: string) {
  return useQuery({
    queryKey: ["contact-consent", subjectType, subjectId],
    queryFn: () => fetchContactConsent(subjectType, subjectId),
    enabled: Boolean(subjectId),
  });
}
